<template>
  <div class="qty-input-container">
    <button
      :disabled="!canDecrement || quantity < 2"
      @click="handleAddDecQty('-')"
    >
      <font-awesome-icon icon="fa-solid fa-minus" />
    </button>
    <input
      min="1"
      class="qty-input"
      type="number"
      v-model="quantity"
      :disabled="disabled || disableInput || !canIncrement"
      :style="disabled ? 'color: #999' : disableInput && 'color: #111'"
    />
    <button :disabled="disabled || !canIncrement" @click="handleAddDecQty('+')">
      <font-awesome-icon icon="fa-solid fa-plus" />
    </button>
  </div>
</template>

<script>
export default {
  name: "QuatityInput",
  props: {
    value: {
      type: Number,
      default: 1,
    },
    canIncrement: {
      type: Boolean,
      default: true,
    },
    canDecrement: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableInput: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["change", "increase", "decrease"],

  model: {
    prop: "value",
    event: "change",
  },

  data() {
    return {
      quantity: this.value,
    };
  },

  methods: {
    handleAddDecQty(action) {
      if (action === "-") {
        this.quantity -= 1;
        this.$emit("decrease", this.quantity);
      } else if (action === "+") {
        this.quantity += 1;
        this.$emit("increase", this.quantity);
      }
    },
  },

  watch: {
    quantity() {
      this.$emit("change", +this.quantity);
    },

    value(newVal) {
      this.quantity = +newVal;
    },
  },
};
</script>

<style>
.qty-input-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 10px;
}

.qty-input-container button {
  background: none;
  border: none;
  border-radius: 999px;
  padding: 5px;
  color: #666;
  outline: none;
}

.qty-input-container button:hover {
  background: #eee !important;
  cursor: pointer;
}

.qty-input-container button:disabled {
  opacity: 0.2;
  background: none !important;
  cursor: default;
}

.qty-input {
  border-radius: 10px;
  width: 45px;
}

.qty-input:not(:disabled) {
  border: 1px solid #999;
}

.qty-input::-webkit-outer-spin-button,
.qty-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
